export default __webpack_public_path__ + "static/media/ITAM-BNB.75839f89.svg";